/** A PR sidebar section's heading: Reviewers, AI code, Checks, Labels. */
export const SIDEBAR_HEADING_CLASS = 'text-xs text-zinc-400';

/** The value at the end of a sidebar heading row, such as AI code's percentage or the checks count. */
export const SIDEBAR_HEADING_VALUE_CLASS = 'text-[11px] font-medium tabular-nums text-zinc-400';
